var exports = {
  "Q": "MacPermissionsModal.module__content___Zi14VD",
};

module.exports = exports;
